import React from "react";
import { motion } from "framer-motion";
import useTitle from "../../hooks/useTitle";

const ProjectsPage = () => {
	useTitle("Projects");

	return (
		<div>
			<h1>Projects Page</h1>
		</div>
	);
};

export default ProjectsPage;
